module.exports = __webpack_public_path__ + "img/filtrate_pic.1ff50354.svg";